import React, { Fragment, useState, useEffect } from 'react';
import numeral from 'numeral';

import { useTranslation } from 'react-i18next/hooks';

import Button from '../../../Button/Button';
// import Img from "react-cool-img";
import FilesUploadAction from '../../../FileUploadAction/FilesUploadAction';
import GroupKuraFileCopy from './GroupKuraFileCopy';
import Loader from '../../../Loader/Loader';

import { useStore } from '../../../../hook-store/store';
import { 
  copyDifferentBucketObjects,
  getOriginalFileNameFromKey,
 } from '../../../../util/bucket/bucket-object-util';

import { 
  KURASTORAGE_BACKENDURL,
  KURAIMAGEPHOTO_BACKENDURL,
  KURASTORAGE_URL,
  KURAIMAGEPHOTO_URL,
  SOCKET_GROUP_URL,
} from '../../../../App';

import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextFileKura.module.css';
// import './VideoTextTalk.css'




const GroupTalkTextFileKuraPreview = (props) => {
  // console.log('VideoTextTalkTextFile.js props', props);
  const {
    // textInputList,
    inputData,
    setShowSepImageHandler,
    fileUrl,
    isDownLoading,
    errorMessage,
    // userId,
    // destUser,
    // noconnectTextDeleteHandler,
    // isLoading,
  } = props;


  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    // selectedKuraFileData,
    // isGroupMember,
    userGetGroupKuraFileDataList,
  } = store.groupStore;

  const [showFileUpload, setShowFileUpload] = useState(false);
  // const [copyDestination, setCopyDestination] = useState('image-photo');

  let foundKuraFileData;
  let isImageFile = false;
  
  // useEffect(() => {
  //   if (isImageFile) {
  //     console.log('isImageFile', isImageFile);
  //   }
  // },[isImageFile]);


  const showFileUploadHandler = () => {
    setShowFileUpload(true);
  };

  // const downloadPreviewFileHandler = () => {
  //   window.open(fileUrl, '_blank', 'noopener','noreferrer')
  //   //  .focus(); 
  // };




  // const copyDiffrentBucketObjectHandler = async (
  //   bucket, 
  //   key,
  //   // initialKey,
  // ) => {
  //   try {
  //     // console.log(bucket, key)
  //     // return;
  //     let url = SOCKET_GROUP_URL;

  //     // if (copyDestination === 'kura-storage') {
  //     //   url = KURASTORAGE_BACKENDURL
  //     // }

  //     // if (copyDestination === 'image-photo') {
  //     //   url = KURAIMAGEPHOTO_BACKENDURL;
  //     // }

  //     const resData = await copyDifferentBucketObjects(
  //       url,
  //       localStorage.getItem('token'),
  //       bucket,
  //       [key],
  //       localStorage.getItem('customerId'),
  //       'groupTalk',
  //       inputData.groupRoomId,
  //       copyDestination,
  //       // [initialKey],
  //     );
  //   } catch(err) {
  //     console.log(err);
  //     throw err;
  //   }
  // }


  const kuraFileInfo = inputData.kuraFileInfo;

  
  if (userGetGroupKuraFileDataList && userGetGroupKuraFileDataList.length > 0) {
    const roomFileData = userGetGroupKuraFileDataList.find(element => {
      return element.groupRoomId === inputData.groupRoomId;
    });
  
    if (roomFileData) {
      const fileList = roomFileData.files;

      // console.log('fileList', fileList)
  
      if (fileList && fileList.length > 0 && kuraFileInfo) {
        const fileData = fileList.find(ele => {
          return ele.kuraFileInfo.bucket === kuraFileInfo.bucket && 
            ele.kuraFileInfo.key === kuraFileInfo.key;
        });
  
        // // console.log(fileData)
        if (fileData) {
          foundKuraFileData = fileData;

          if (fileData.kuraFileInfo && fileData.kuraFileInfo.mimeType &&
                fileData.kuraFileInfo.mimeType.split('/')[0] === 'image'
          ) {
              isImageFile =true;
            } else {
              isImageFile = false;
            }
          // console.log('fileData', fileData);
          // if (fileData.url) {
          //   kuraFileImageUrl = fileData.url;
          // }
          // if (fileData.smallImageUrl) {
          //   kuraFileImageUrl = fileData.smallImageUrl;
          // }
          
          // if (fileData.isNotFoundError) {
          //   isNotFoundError = true;
          // }
        }
      }
    }
  }

  // console.log('foundKuraFileData', foundKuraFileData)
  // console.log('isImageFile', isImageFile)
  let kuraFilePreviewBody;

  if (kuraFileInfo) {
    kuraFilePreviewBody = (
      <div>
        <div className={classes.textTalkFileKuraPreviewClose}>
          <span className={classes.textTalkFileKuraPreviewCloseButton}
            onClick={() => { 
              setShowSepImageHandler(false);
            }}
          >
            X
          </span>
        </div>
        <div className={classes.textTalkFileKuraSection}>
          {fileUrl && kuraFileInfo.mimeType?.split('/')[0] === 'image' && (
            <img 
            // className={classes.textTalkFileKuraMedia}
              className={classes.textTalkFileKuraPreviewImage}
              src={fileUrl}
              alt='kura-file'
            />
          )}
          {fileUrl && kuraFileInfo.mimeType?.split('/')[0] === 'audio' && (
            <audio className={classes.textTalkFileKuraPreviewMedia}
              src={fileUrl}
              controls
            />
          )}
          {fileUrl && kuraFileInfo.mimeType?.split('/')[0] === 'video' && (
            <video 
              className={classes.textTalkFileKuraPreviewMedia}
              src={fileUrl}
              controls
            />
          )}
        </div>
        {errorMessage && (
          <div>{errorMessage}</div>
        )}
        {isDownLoading && (
          <Loader />
        )}

        {fileUrl && (
          <GroupKuraFileCopy 
            inputData={inputData}
            foundKuraFileData={foundKuraFileData}
            // fileUrl={fileUrl}
          />
        )}
      </div>
    )
  }




  return (
    <Fragment>
      {kuraFilePreviewBody}
      {showFileUpload && (
        <div>
          <FilesUploadAction 
            filePaths={inputData.filePaths}
            uploadApp={`groupTalk-${inputData.groupRoomId}`}
            kuraFileInfo={inputData.kuraFileInfo}
            groupRoomId={inputData.groupRoomId}
          />
        </div>
      )}
    </Fragment>
  );
};

export default GroupTalkTextFileKuraPreview;